import { useRef } from 'react';

import MessageCenterHeader from '../components/MessageCenterHeader';
import MessageCenterChat from '../components/MessageCenterChat';

import DrawerScreenLayout from 'modules/common/components/RightDrawer/DrawerScreenLayout';
import GoBack from 'modules/IMC/common/IMCHeader/actions/GoBack';

function GoBackWithScreen() {
    return <GoBack screen="home" />;
}

function Chat({ id }: { id: number }) {
    const containerRef = useRef(null);

    return (
        <DrawerScreenLayout containerRef={containerRef}>
            <MessageCenterHeader containerRef={containerRef} startAction={GoBackWithScreen} compressed />
            <MessageCenterChat ticketId={id} />
        </DrawerScreenLayout>
    );
}

export default Chat;
